<template>
  <div id="pageDestinies">
    <v-container grid-list-xl fluid>
      <v-btn
        class="btn-add"
          color="white"
          small
          absolute
          fab
          :to="{ name: 'AuxDestinyNew'}"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-container fill-height fluid>
          <v-layout fill-height>
            <v-flex xs2>
              Id
            </v-flex>
            <v-flex xs3>
              Nome
            </v-flex>
          </v-layout>
        </v-container>
      <div class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="paginatationDisabled"
        ></v-progress-circular>
      </div>
      <v-card class="card-destinyAux" v-for="(destinyAux, index) in destinyAuxs.data" :key="`destinyAux${destinyAux.id}`">
        <v-container>
          <v-layout>
            <v-flex xs2>
              <p style="margin: 6px 0px;">{{destinyAux.id}}</p>
            </v-flex>
            <v-flex xs3>
              <p style="margin: 6px 0px;">{{destinyAux.name}}</p>              
            </v-flex>
            <v-flex xs7 class="text-xs-right">
              <v-btn fab small :to="{ name: 'AuxDestinyEdit', params: { id: destinyAux.id }}" color="primary"><v-icon>edit</v-icon></v-btn>
              <v-btn fab small color="error" @click.stop="clickDeleteDestiny(index)"><v-icon>delete</v-icon></v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <app-pagination v-if="destinyAuxs && destinyAuxs.pagination"
        :pagination="destinyAuxs.pagination"
        :disabled="paginatationDisabled"
        v-on:change-page="changePage"
        ></app-pagination>
      <app-confirm-modal 
        :message="deleteMessage" 
        :dialog="dialog" 
        :modalType="modalType"
        v-on:choose="deleteDestiny"></app-confirm-modal>
      
      <v-snackbar
        :timeout="3000"
        bottom
        right
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn dark text @click.native="snackbar.show = false" icon> 
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>    
    </v-container>
  </div>
</template>

<script>
import appApi from '../../../plugins/api';
import AppPagination from '../../../components/Pagination';
import ConfirmModal from '../../../components/ConfirmModal';

export default {
  components: {
    'app-pagination' : AppPagination,
    'app-confirm-modal' : ConfirmModal
  },
  data: function() {
    return {
      destinyAuxs : {},
      paginatationDisabled : false,
      dialog : false,
      deleteDestinyId : null,
      deleteMessage : '',
      modalType : null,
      snackbar : {}
    }
  },

  computed: {
  },

  mounted: function() {
    this.getAuxDestiny();
  },

  methods: {
    getAuxDestiny: function(page) {
      this.paginatationDisabled = true;
      this.destinyAuxs.data = [];
      appApi.getAuxDestinies({page : (page ? page : 1)}).then(result => {
        this.destinyAuxs = result.data;
        this.paginatationDisabled = false;
      }).catch(error => {
        console.log('error', error);
      });
    },
    changePage(page) {
      this.getAuxDestiny(page);
    },
    clickDeleteDestiny(index) {
      this.dialog = true;
      this.deleteDestinyId = index;
      this.modalType = 'error';
      this.deleteMessage = 'Tem certeza que deseja deletar <strong>'+this.destinyAuxs.data[index].name+'</strong>?';
    },
    deleteDestiny(confirm) {
      this.dialog = false;
      if (confirm) {
        appApi.deleteAuxDestiny(this.destinyAuxs.data[this.deleteDestinyId].id).then(()=>{
          this.changePage(1);
          this.snackbar = {
            show: true,
            color: "green",
            text: "Apagado com sucesso."
          };
        }).catch(()=>{
          this.changePage(1);
          this.snackbar = {
            show: true,
            color: "error",
            text: "Não foi possível apagar."
          };
        });
      }
    }
  }

};
</script>
<style scoped lang="css">
  #pageDestinies {
    position: relative;
  }
  #pageDestinies .btn-add {
    position: fixed;
    top: 90px;
    left: calc(100% - 60px);
  }
  #pageDestinies .card-destinyAux {
    margin-bottom: 10px;
  }
</style>

